module.exports = __webpack_public_path__ + "media/images/boxed-bg-0de93c39950fc78a1f792e154d9e7df5.jpg";